import React from 'react';

import type { MessageContent } from '@captivateiq/assistant/types';

import { ChartBlockRenderer } from './ChartBlockRenderer';
import { ColumnTraceBlockRenderer } from './ColumnTraceBlockRenderer';
import { SummaryCardBlockRenderer } from './SummaryCardBlockRenderer';
import { TableBlockRenderer } from './TableBlockRenderer';

type Props = { blocks: MessageContent[] };

export const ContentBlockRenderer = ({ blocks }: Props) => {
  return (
    <>
      {blocks.map((block, index) => {
        switch (block.type) {
          case 'chart':
            // eslint-disable-next-line react/no-array-index-key -- blocks are a static array on a message, never reordered
            return <ChartBlockRenderer block={block} key={`chart-${index}`} />;
          case 'table':
            // eslint-disable-next-line react/no-array-index-key -- blocks are a static array on a message, never reordered
            return <TableBlockRenderer block={block} key={`table-${index}`} />;
          case 'summary_card':
            // eslint-disable-next-line react/no-array-index-key -- blocks are a static array on a message, never reordered
            return <SummaryCardBlockRenderer block={block} key={`summary-${index}`} />;
          case 'column_trace':
            // eslint-disable-next-line react/no-array-index-key -- blocks are a static array on a message, never reordered
            return <ColumnTraceBlockRenderer block={block} key={`column-trace-${index}`} />;
          default:
            return null;
        }
      })}
    </>
  );
};
